import { PlusInSquareIcon } from "assets/icons";
import { useBoolean } from "hooks";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { ClipLoader } from "react-spinners";
import { Button, Input } from "ui";

import { useGetQuiz, useQuizUpdate } from "../../apis";
import { QuizModal, QuizTable } from "../../components";

import styles from "./Quiz.module.scss";
const Quiz = () => {
  const { t } = useTranslation();

  const {
    value: isQuestionModalOpen,
    setTrue: openQuestionModal,
    setFalse: closeQuestionModal
  } = useBoolean(false);

  const { quizzes, correctAnswersNeededToPass, isLoading, refetch } =
    useGetQuiz();

  const { mutate: updateQuiz } = useQuizUpdate({
    onSuccess: () => toast.success(t("Quiz has been updated successfully"))
  });

  const [editableItemIndex, setEditableItemIndex] = useState<number | null>(
    null
  );

  const [currentMinCorrectAnswersForPass, setCurrentMinCorrectAnswersForPass] =
    useState(correctAnswersNeededToPass ?? 0);

  useEffect(() => {
    if (correctAnswersNeededToPass !== undefined) {
      setCurrentMinCorrectAnswersForPass(correctAnswersNeededToPass);
    }
  }, [correctAnswersNeededToPass]);

  return (
    <div className={styles.quiz}>
      {isLoading && (
        <div className={styles.quiz_loader}>
          <ClipLoader size={30} color="#fb3973" />
        </div>
      )}

      {quizzes && correctAnswersNeededToPass !== undefined && (
        <>
          <div className={styles.quiz_headerControls}>
            <div className={styles.quiz_headerControls_pass}>
              <Input
                label={"Min. correct answers for pass"}
                className={styles.quiz_headerControls_input}
                value={currentMinCorrectAnswersForPass}
                onChange={(e) =>
                  setCurrentMinCorrectAnswersForPass(Number(e.target.value))
                }
              />

              <Button
                title={"Save"}
                disabled={
                  currentMinCorrectAnswersForPass ===
                    correctAnswersNeededToPass ||
                  currentMinCorrectAnswersForPass < 1
                }
                onClick={() => {
                  updateQuiz({
                    correctAnswersNeededToPass: currentMinCorrectAnswersForPass,
                    quizzes
                  });
                }}
              />
            </div>
            <Button
              title={"Add Question"}
              icon={<PlusInSquareIcon />}
              onClick={openQuestionModal}
            />
          </div>

          <div className={styles.quiz_tableContainer}>
            <QuizTable
              quizList={quizzes}
              correctAnswersNeededToPass={correctAnswersNeededToPass}
              onEditItem={(index) => {
                setEditableItemIndex(index);
                openQuestionModal();
              }}
            />
          </div>

          <QuizModal
            isOpen={isQuestionModalOpen}
            onClose={() => {
              closeQuestionModal();
              setEditableItemIndex(null);
            }}
            editableItemIndex={editableItemIndex}
            quizzes={quizzes}
            correctAnswersNeededToPass={correctAnswersNeededToPass}
            refetchQuiz={refetch}
          />
        </>
      )}
    </div>
  );
};

export default Quiz;
